var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F5F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1247 29C41.1247 25.691 38.3778 23 35 23C31.6222 23 28.8753 25.691 28.8753 29C28.8753 32.309 31.6222 35 35 35C38.3778 35 41.1247 32.309 41.1247 29ZM46.9187 50H44.1871C43.3418 50 42.6559 49.328 42.6559 48.5C42.6559 47.672 43.3418 47 44.1871 47H44.8439C45.9035 47 46.6859 45.9545 46.2848 44.993C44.4305 40.547 40.0759 38 35 38C29.9242 38 25.5695 40.547 23.7153 44.993C23.3141 45.9545 24.0965 47 25.1561 47H25.813C26.6582 47 27.3442 47.672 27.3442 48.5C27.3442 49.328 26.6582 50 25.813 50H23.0814C21.1674 50 19.6607 48.2855 20.0665 46.454C21.1812 41.4155 24.6615 37.697 29.2459 36.0095C27.1543 34.361 25.813 31.835 25.813 29C25.813 23.6735 30.5351 19.4285 36.1009 20.063C40.134 20.522 43.4751 23.6705 44.0799 27.605C44.6005 30.9965 43.1841 34.094 40.7542 36.0095C45.3385 37.697 48.8189 41.4155 49.9335 46.454C50.3393 48.2855 48.8326 50 46.9187 50ZM39.7788 43.196C40.3775 43.7825 40.3775 44.732 39.7788 45.3185L35 50L31.7524 46.8185C31.1537 46.232 31.1537 45.2825 31.7524 44.696C32.3496 44.111 33.3188 44.111 33.9175 44.696L35 45.758L37.6138 43.196C38.2124 42.611 39.1817 42.611 39.7788 43.196Z",
    fill: "#304659"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.cc0c0ef51c5f3478620ec59d6a5a94a3.svg";
export { ForwardRef as ReactComponent };